module.exports = __webpack_public_path__ + "media/images/screen-984a37dbdb5821f078aeab9cff9dfaf4.jpg";